import React from 'react'
import Footer from '../Components/Footer';
import Navbar from '../Components/Navbar';
import About from "../Components/About";

const CompaniesPage = () => {
  return (
    <>
      <Navbar/>
      <About />
      <Footer />
      
    </>
  );
};

export default CompaniesPage;
